(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/frejaeid/assets/javascripts/views/frejaeid.js') >= 0) return;  svs.modules.push('/components/app/frejaeid/assets/javascripts/views/frejaeid.js');

(function(Backbone, svs) {
  'use strict';

  svs.app.frejaeid.views.FrejaEid = Marionette.View.extend({
    template: function(data) {
      return svs.app.frejaeid.templates.frejaeid(data);
    },
    modelEvents: {
      'change:progressText': 'render'
    },
    ui: {
      frejaeidThisDeviceBtn: '.js-this-device-button',
      frejaeidOtherDeviceBtn: '.js-other-device-button'
    },
    events: {
      'click @ui.frejaeidThisDeviceBtn': 'frejaeidThisDeviceBtnClick',
      'click @ui.frejaeidOtherDeviceBtn': 'frejaeidOtherDeviceBtnClick'
    },
    frejaeidThisDeviceBtnClick: function() {
      $('.this-device-button').hide();
      $('.other-device-button').hide();
      $('.progressText').text('Försöker starta Freja eID-appen');
      $('.frejaeid-loader-large-container').show();
      $('.progressText').show();
      window.location.href = svs.app.frejaeid.getFrejaEidStartParams(this.getOption('authRef'));
    },
    frejaeidOtherDeviceBtnClick: function() {
      $('.this-device-button').hide();
      $('.other-device-button').hide();
      $('.qrCode').show();
      $('.progressText').show();
      $('.frejaeid-loader-large-container').show();
      this.trigger('modalContentResize');
    },
    templateContext: function() {
      var fallbackStartUrl = svs.app.frejaeid.getFrejaEidStartParams(this.getOption('authRef'));
      var fallbackLinkClass;
      if (svs.core.detect.formfactor.mobile()) {
        fallbackLinkClass = 'animate animate-show animate-time-long animate-delay-5s margin-xs-top-2';
      } else {
        fallbackLinkClass = 'margin-xs-top-2';
      }
      return {
        fallbackStartUrl: fallbackStartUrl,
        fallbackLinkClass: fallbackLinkClass
      };
    },
    onRender: function() {
      $('.progressText').show();
      $('.this-device-button').hide();
      $('.other-device-button').hide();
      this.trigger('modalContentResize');
    },
    onAttach: function() {
      this.loader = new svs.components.Loader('.js-frejaeid-loader-large-inverted').show(300, 'inverted');
      if (svs.core.detect.formfactor.mobile()) {
        window.location.href = svs.app.frejaeid.getFrejaEidStartParams(this.getOption('authRef'));
      } else {
        svs.app.frejaeid.qrCodeGenerate(this.getOption('authRef'));
      }
    },
    onDestroy: function() {
      this.loader.hide();
    }
  });
})(Backbone, svs);


 })(window);